<template>
  <!--    <transition name="fade">-->
  <div id="tooltip" class="card card-tooltip" v-show="showTooltip"
       :style="`top:${info.position.top}; left:${info.position.left};`">
    <header class="card-header" v-if="info.section || info.description">
      <p class="card-header-title is-centered">{{ info.section ? info.section : info.description }}</p>
    </header>
    <div v-if="info.row || ((info.number!=='')&&(info.number!==' '))"
         class="card-content is-flex">
      <div v-if="info.is_cam">За данными местами возможна плохая видимость!</div>
      <div v-if="info.row">Ряд: {{ info.row }}</div>
      <div v-if="((info.number)&&(info.number!==' '))">Место: {{ info.number }}</div>
      <div v-if="info.freePlaceQuantity">Свободно мест: {{ info.freePlaceQuantity }}</div>
    </div>
    <footer class="card-footer has-text-centered is-size-7" v-if="!info.is_cam">
      <strong v-if="info.price">{{ info.price }} руб.</strong>
      <strong v-if="typeof info.minTicketCost !== 'undefined' && typeof info.maxTicketCost !== 'undefined'">
        <template v-if="info.minTicketCost && info.minTicketCost !== info.maxTicketCost">
          от {{ info.minTicketCost }} руб.<br>до {{ info.maxTicketCost }} руб.
        </template>
        <template v-else-if="!!info.minTicketCost">
          по {{ info.minTicketCost }} руб.
        </template>
        <template v-else-if="!!info.maxTicketCost">
          по {{ info.maxTicketCost }} руб.
        </template>
      </strong>
    </footer>
  </div>
  <!--    </transition>-->
</template>

<script>
export default {
  name: "WTooltip",
  data() {
    return {
      showTooltip: false,
      info: {
        description: '',
        section: '',
        price: '',
        row: '',
        number: '',
        freePlaceQuantity: '',
        minTicketCost: '',
        maxTicketCost: '',
        position: {
          left: 0,
          top: 0,
        }
      },
    }
  },
  events: {
    showTooltip(data) {
      // let tooltip = document.getElementById('tooltip');
      // tooltip.style.left = data.position.left + (data.position.width / 2) + "px";
      // tooltip.style.top = data.position.top + (data.position.height / 2) + "px";

      this.info = data;
      this.showTooltip = true;

    },
    hideTooltip() {
      this.showTooltip = false;
    }
  }
}
</script>

<style scoped lang="scss">

.card-tooltip {
  position: absolute;
  width: 10rem;
  transform: translate(-5rem, 1.5rem);
  border-radius: .25rem;

  /*&:before {
      position: absolute;
      content: "";
      width: 0;
      height: 0;
      left: 50%;
      margin-left: -.5rem;
      margin-top: -.25rem;
      border-left: .5rem solid transparent;
      border-right: .5rem solid transparent;
      border-bottom: .75rem solid white;
  }*/

  .card {
    &-header {
      &-title {
        padding: 0.375rem .5rem .25rem;
        text-align: center;
        line-height: 1em;
      }
    }

    &-content {
      padding: 0.25rem .5rem;
      justify-content: center;

      > div {
        margin: auto .5rem;
      }
    }

    &-footer {
      padding: 0.25rem .5rem;
      justify-content: center;
    }
  }
}
</style>
